<template>
  <div>
    <div class="creation-option-container">
      <div class="icon-label-container">
        <v-icon class="creation-option-icon">more_horiz</v-icon>
        <div class="creation-option-label">{{ $t("NumberOf")}}</div>
      </div>
      <v-slider
        v-model="count"
        thumb-label="always"
        :thumb-size="27"
        color="var(--primary-highlight)"
        thumb-color="var(--primary-highlight)"
        track-color="#DDDDDD"
        style="margin: 0 10px 0 20px"
        @input="updateNumber($event)"
        @start="$emit('toggle-drag', true)"
        @end="$emit('toggle-drag', false)"
      />
    </div>
    <div class="creation-option-container">
      <div class="icon-label-container">
        <v-icon class="creation-option-icon" style="transform: rotate(90deg)">expand</v-icon>
        <div class="creation-option-label">{{ $t("DistanceBetween") }}</div>
      </div>
      <input
        class="distance-between-tps-input-field"
        :class="{ 'too-many-points': tooManyPointsDrawn }"
        id="distanceBetweenTPs"
        type="number"
        v-model="distanceBetweenTPs"
        :min="1"
        @input="updateDistance($event)"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "BulkTPCreationOptions",

  props: {
    tooManyPointsDrawn: {
      type: Boolean,
      required: true
    },
    count:{
      type:Number
    }
  },

  data() {
    return {
      distanceBetweenTPs: null
    }
  },

  methods: {
    /**
     * Emits an event to update the distance value in the parent component and
     * updates the value of the numberOfTPs variable
     */
    updateDistance: _.debounce(function(value) {
      this.$emit('update-distance', {
        distance: parseInt(value.target.value),
        number: 0
      });
    }, 1000),

    /**
     * Emits an event to update the numberOfTPs value in the parent component and
     * updates the value of the distanceOfTPs variable
     */
    updateNumber(value) {
      this.distanceBetweenTPs = null;
      this.$emit('update-number', {
        distance: null,
        number:  value
      });
    },
  }
}
</script>

<style scoped>
.creation-option-container {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}

.creation-option-label {
  width: 60px;
  text-align: center;
}

.creation-option-icon {
  font-size: 20px;
}

.icon-label-container {
  width: 60px;
  display: flex;
  flex-direction: column;
  align-content: center;
}

.distance-between-tps-input-field {
  border: 1px solid lightgrey;
  padding: 2px 4px;
  width: 114px;
  height: 30px;
  margin-left: 28px;
}

.too-many-points {
  border: 1px solid red
}

</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/BulkTP/BulkTPCreationOptions.vue